export enum ProfileRow {
  photo = 0,
  name = 1,
  email = 2,
  phone = 3,
  username = 4,
  password = 5,
  date_format = 6,
  location = 7,
  order = 8,
}

export const ProfileRowList: any[] = [
  {
    name: 'Employee Profile Photo',
    hidden: false,
  },
  {
    name: 'Name',
  },
  {
    name: 'Contact Email',
  },
  {
    name: 'Contact Phone Number',
    hidden: true,
  },
  {
    name: 'RxPhoto Username',
  },
  {
    name: 'RxPhoto Password',
  },
  {
    name: 'Preferred Date Format',
  },
  {
    name: 'Default Clinic Location',
  },
  {
    name: 'Preferred Default Client Ordering (Web Application)',
  },
];
